import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../mutation-types';
import inventoryApi from "../../../api/inventory";

const defaultState = () => ({
    dataStock: [],
    stockSerial: [],
    detailStock: [],
    riwayatStock: [],
    pagination: {},
    paginationSerial: {},
    listStockResults: []
});

const state = defaultState();

const getters = {};

const mutations = {
    listStock(state, data) {
        state.dataStock = data.map(el => {
          let code_name =  `${el.product_code} - ${el.product_name}`;
          let maxlength = 30
          if(code_name.length > maxlength) {
            code_name = code_name.substr(0, maxlength) + "..."
          }
          el.product_code_name = code_name
          return el
        });
    },

    dataSerial(state, data) {
        state.stockSerial = data;
    },

    listDetailStock(state, data) {
        state.detailStock = data;
    },
    listDataStockByDate(state, data) {
        state.riwayatStock = data.data;
        state.pagination = data.pagination;
    },
    listSerial(state, data) {
        state.listStockResults = data.data;
        state.paginationSerial = data.pagination;
    },
};
const actions = {
    // untuk yg stock diatas
    getStock({ commit }, params) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            inventoryApi.getDataStock(params).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listStock', 'error');
                } else {
                    commit("listStock", data.results);
                }
                const serial = data.results.filter((item) => item.product_is_serial !== "0");
                if (serial.length == 0) {
                    commit('dataSerial', 'error');
                } else {
                    commit("dataSerial", serial);
                }
                resolve();
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch(() => {
                commit('dataSerial', 'error');
                commit(PROGRESS_FAIL, null, { root: true });
            });
        })
    },

    getDataStockSummarySerial({ commit }) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            inventoryApi.getDataStockSummarySerial().then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('dataSerial', 'error');
                } else {
                    commit("dataSerial", data.results);
                }
                commit(PROGRESS_FINISH, null, { root: true });
                resolve()
            }).catch(() => {
                commit('dataSerial', 'error');
                commit(PROGRESS_FAIL, null, { root: true });
            });
        })
    },

    // untuk detailnya
    getDetailStock({ commit }, param) {
        commit("listDetailStock", []);
        commit(PROGRESS_START, null, { root: true });
        inventoryApi.getDetailStock(param).then(({ data: { data } }) => {
            commit("listDetailStock", data.results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getDataStockByDate({ commit }, value) {

        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            inventoryApi.getDataStockByDate(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataStockByDate', { data: 'error', pagination: data.pagination });
                } else {
                    commit("listDataStockByDate", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            inventoryApi.getDataStockByDate({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataStockByDate', { data: 'error', pagination: data.pagination });
                } else {
                    commit("listDataStockByDate", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },

    getListSerial({ commit, dispatch }, params) {

        commit(PROGRESS_START, null, { root: true });
        inventoryApi.getDataStockSerial(params).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listSerial', { data: 'error', pagination: data.pagination });
            } else {
                commit('listSerial', { data: data.results, pagination: data.pagination });
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    convertSerialStock({ commit }, params) {
      return new Promise((resolve, reject) => {
        commit(PROGRESS_START, null, { root: true });
        inventoryApi.convertSerialStock(params).then(({ data }) => {
          commit(PROGRESS_FINISH, null, { root: true });
          resolve(data.message)
        }).catch( err => {
          commit(PROGRESS_FAIL, null, { root: true })
          reject(err.response)
        });
      })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
